module.exports = __webpack_public_path__ + "static/media/photo-7.708bcb3a.jpg";